import { useQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';

import { getPriceChange } from '~/services/price/price-service';

const QUERY_KEY_PRICE_CHANGE_HISTORY = 'QUERY_KEY_PRICE_CHANGE_HISTORY';

interface UsePriceChangeHistoryProps {
  ticker: string;
  from: string;
  to: string;
  reference: string;
  enabled?: boolean;
}

export const usePriceChangeHistory = ({
  ticker,
  from,
  to,
  reference,
  enabled = true,
}: UsePriceChangeHistoryProps) =>
  useQuery({
    queryKey: [QUERY_KEY_PRICE_CHANGE_HISTORY, ticker, reference, from, to],
    queryFn: () => getPriceChange({ ticker, reference, from, to }),
    staleTime: getTimeTillEndOfDayMs(),
    enabled,
  });
